import { authenticationService } from './../services/authentication.service';

export function authHeader() {
    // return authorization header with jwt token
    const currentUser = authenticationService.currentUserValue;
    if (currentUser && currentUser.token) {
        return { 'Authorization': `KEYESPOL ${currentUser.token}` };
    } else {
        return {};
    }
}

export function authHeaderWithToken(Token) {
    return { 
        'Authorization': `KEYESPOL ${Token}` 
    };
}

export function authHeaderWithUserData(dataUser) {
    
    
    if(dataUser === null || dataUser === undefined){
        return {}
    }
    else{
        return { 
            'Authorization': `KEYESPOL ${dataUser.token}` 
        };
    }
    
}